<template>
  <ReportTableWithHeader
    :loading="isLoading"
    :downloading="isDownloading"
    :rows="rows"
    :columns="columns"
    :page="page"
    :per-page="perPage"
    :page-size="pageSize"
    :total-page="totalPage"
    :total-records="totalRecords"
    downloadable
    :type="reportType"
    :form="form"
    @onFilter="onFilter"
    @onPageChange="onPageChange"
    @onPerPageChange="onPerPageChange"
    @onDownload="onDownload"
  />
</template>

<script>
import reportTableMixin from '@/mixins/reportTableMixin';

export default {
  mixins: [reportTableMixin],

  data() {
    return {
      columns: [
        { field: 'account' },
        { field: 'userName' },
        { field: 'currency' },
        { field: 'startDate' },
        { field: 'endDate' },
        { field: 'amount' },
        { field: 'amount' },
        { field: 'totalRateAmount' },
        { field: 'increaseRateAmount' },
        { field: 'userBank' },
        { field: 'bankAccount' },
        { field: 'loanStatus' },
        { field: 'officerName' },
        { field: 'userRegister' },
      ],
      reportType: 'creditAccountBalance',
    };
  },

  methods: {
    updateFilters(data) {
      data.filters[`filter[status]`] = 'ACTIVE';
      data.filters[`filter[reportType]`] = this.reportType;
    },
  },
};
</script>
